import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonCustomerList } from "./Common/CommonCustomerList";

const CustomerPage = () => {
	return (
		<PageWrapper title='Clientes'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonCustomerList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default CustomerPage;